import { Box, Typography } from '@mui/material';
import { CSSProperties, FC } from 'react';

type FrsDescriptionContentProps = {
  value?: string | null;
  style?: CSSProperties;
};

const isEmptyDescription = (html?: string | null) => {
  const trimmed = (html ?? '').trim();
  if (!trimmed) return true;
  return trimmed === '<p></p>' || trimmed === '<p>&nbsp;</p>';
};

export const FrsDescriptionContent: FC<FrsDescriptionContentProps> = ({
  value,
  style,
}) => {
  if (isEmptyDescription(value)) {
    return (
      <Typography variant="body2" color="textSecondary" style={style}>
        -
      </Typography>
    );
  }

  return (
    <Box
      className="ck-content frs-description-content"
      style={{ fontSize: '0.75rem', ...style }}
      dangerouslySetInnerHTML={{ __html: value ?? '' }}
    />
  );
};

export default FrsDescriptionContent;
